import { EApiType } from '../enums/api-type.enum';

export const ENV_API_URL = process.env.REACT_APP_API_URL || '';
export const ENV_COUNTERPARTY_GUID = process.env.REACT_APP_COUNTERPARTY_GUID || '';
export const ENV_ASSET_CODE = process.env.REACT_APP_ASSET_CODE || '';
export const ENV_ASSET_ISSUER = process.env.REACT_APP_ASSET_ISSUER || '';
export const ENV_ACCOUNT_GUID = process.env.REACT_APP_ACCOUNT_GUID || '';
export const ENV_API_TYPE: EApiType = (process.env.REACT_APP_API_TYPE as EApiType) || '';
export const ENV_IS_PROD = process.env.REACT_APP_ENV_NAME?.includes('prod');

export const ENV_MAIN_LOGO = process.env.REACT_APP_MAIN_LOGO || '';
export const ENV_COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || '';
